import PersonalDataIcon from 'assets/icons/icon-personal-data.svg';
import PrecontractualDocsIcon from 'assets/icons/icon-precontractual-docs.svg';
import EmailOTPValidationIcon from 'assets/icons/icon-email-otp-validation.svg';
import AccessDataIcon from 'assets/icons/icon-access-data.svg';
import EditIcon from 'assets/icons/icon-edit-3-bold.svg';
import EyeIcon from 'assets/icons/icon-password-show.svg';
import { SECTION_TYPE } from '../constants';

const { PERSONAL_DATA, PRECONTRACTUAL_DOCS, EMAIL_OTP_VALIDATION, ACCESS_DATA } = SECTION_TYPE;

export const SectionTypes = {
    [PERSONAL_DATA]: {
        icon: PersonalDataIcon,
        editIcon: EditIcon,
        editText: 'button-modify',
        title: 'initial-complete',
        buttonText: 'button-next',
        editSectionActionPayload: {
            [PERSONAL_DATA]: false,
            [PRECONTRACTUAL_DOCS]: true,
            [EMAIL_OTP_VALIDATION]: true,
            [ACCESS_DATA]: true,
        },
        footerActionPayload: {
            [PERSONAL_DATA]: true,
            [PRECONTRACTUAL_DOCS]: true,
            [EMAIL_OTP_VALIDATION]: true,
            [ACCESS_DATA]: false,
        },
        className: 'personal-data-section',
    },
    [PRECONTRACTUAL_DOCS]: {
        icon: PrecontractualDocsIcon,
        editIcon: EyeIcon,
        editText: 'button-check',
        title: 'precontractualDocSection-readAndAccept',
        buttonText: 'button-next',
        editSectionActionPayload: {
            [PERSONAL_DATA]: true,
            [PRECONTRACTUAL_DOCS]: false,
            [EMAIL_OTP_VALIDATION]: true,
            [ACCESS_DATA]: true,
        },
        footerActionPayload: {
            [PERSONAL_DATA]: true,
            [PRECONTRACTUAL_DOCS]: true,
            [EMAIL_OTP_VALIDATION]: false,
            [ACCESS_DATA]: true,
        },
        className: 'precontractual-docs-section',
    },
    [EMAIL_OTP_VALIDATION]: {
        icon: EmailOTPValidationIcon,
        editIcon: EditIcon,
        editText: 'button-modify',
        title: 'emailValidation-validateYourEmail',
        buttonText: 'button-next',
        editSectionActionPayload: {
            [PERSONAL_DATA]: true,
            [PRECONTRACTUAL_DOCS]: true,
            [EMAIL_OTP_VALIDATION]: false,
            [ACCESS_DATA]: true,
        },
        footerActionPayload: {
            [PERSONAL_DATA]: true,
            [PRECONTRACTUAL_DOCS]: true,
            [EMAIL_OTP_VALIDATION]: true,
            [ACCESS_DATA]: true,
        },
        className: 'email-otp-validation-section',
    },
    [ACCESS_DATA]: {
        icon: AccessDataIcon,
        editIcon: EditIcon,
        editText: 'button-modify',
        title: 'accessDataSection-createYourAccessData',
        buttonText: 'button-start',
        editSectionActionPayload: {
            [PERSONAL_DATA]: true,
            [PRECONTRACTUAL_DOCS]: true,
            [EMAIL_OTP_VALIDATION]: true,
            [ACCESS_DATA]: false,
        },
        footerActionPayload: {
            [PERSONAL_DATA]: true,
            [PRECONTRACTUAL_DOCS]: false,
            [EMAIL_OTP_VALIDATION]: true,
            [ACCESS_DATA]: true,
        },
        className: 'access-data-section',
    },
};
